
// import { useStore } from '@/store'
import moment from 'moment'
import 'moment/dist/locale/zh-cn'
import 'moment/dist/locale/ru'
import {useGetter} from '@/composable/useGetter'


export const useUtils = () => {
    // const lang = computed(() => useStore().lang)
    const { lang } = useGetter(['lang'])

    moment.locale('en-EN')
    if (lang.value === 'cn') moment.locale('zh-cn')
    if (lang.value === 'ru') moment.locale('ru')

    const momentFilter = (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') => {
        return isNaN(dataStr) ? moment(dataStr).format(pattern) : /*moment.unix(dataStr).utc().add(3, 'hours').format(pattern)*/moment.unix(dataStr).local().format(pattern)
    }

    const localize = function (obj) {
        if (typeof obj === 'object') return obj[lang.value]
    }

    const numberFilter = (dataStr, options = {}) => {
        let settings = {
            locale: lang.value === 'en' ? 'en-EN' : 'ru-RU',
            millesimal: '',
            decimal: '.'
        }
        settings = {...settings, ...options}

        let result = dataStr.toString().replace(' ', '')
        result = result.replace(new RegExp(settings.millesimal, 'g'), '')
        result = result.replace(new RegExp(`[${settings.decimal}]`, 'g'), '.')
        result = Number(result)

        if (isNaN(result)) return dataStr

        return result.toLocaleString(settings.locale)
    }

    /**
     * Simple object check.
     * @param item
     * @returns {boolean}
     */
    const isObject = (item) => {
        return item && typeof item === 'object' && !Array.isArray(item)
    }

    /**
     * Deep merge two objects.
     * @param target
     * @param ...sources
     */
    const mergeDeep = (target, ...sources) => {
        if (!sources.length) return target
        const source = sources.shift()

        if (isObject(target) && isObject(source)) {
            for (const key in source) {
                if (isObject(source[ key ])) {
                    if (!target[ key ]) Object.assign(target, { [ key ]: {} })
                    mergeDeep(target[ key ], source[ key ])
                } else {
                    Object.assign(target, { [ key ]: source[ key ] })
                }
            }
        }

        return mergeDeep(target, ...sources)
    }

    return {
        momentFilter,
        localize,
        numberFilter,
        mergeDeep
    }
}
